module.exports = {
  headline: 'FAQ',
  index: ['For sellers & brands','For content makers','For end-customers'],
  list: [

    {
      headers: ["Portal features", "Seller", "Publisher"],
      expandables: [  
        {
          header: 'Account / user management',
          content: '<p>Self-service management and creation of teams accounts and permissions with self-service onboarding</p>',
          columns: [true, true]
        },
        {
          header: 'Analytics & Performance tools',
          content: '<p>Dashboard with analytics of sales, orders top selling items, sources and more (content adapted to seller/publisher roles)</p>',
          columns: [true, true]
        },
        {
          header: 'Partnership management',
          content: '<p>Self-service platform for exploring and finding seller/publisher partners where you agree on commission levels to get up and running in no time.</p>',
          columns: [true, true]
        },
        {
          header: 'Product / catalogue management',
          content: '<p>Spotin’s product manager where sellers can view, manage, and import products, and publishers can Explore and manage your catalogue of products sellers in the Spotin network.</p>',
          columns: [true, true]
        },
        {
          header: 'Order management',
          content: '<p>Spotin’s order management system for sellers. View all orders of producrts sold via Spotin, manage order fulfillment and import or export all order data to/from your ecom platform.</p>',
          columns: [true, false]
        },
        {
          header: 'Campaign management',
          content: '<p>Campaign management tool for all Spotin network partners. Sellers can import external campaigns or create targeted campaigns for selected publishers directly in the portal. Publishers can see available campaigns or make specific request to selling partners.</p>',
          columns: [true, true]
        },
        {
          header: 'Seller e-com system integration',
          content: '<p>Overview and manage the integrations to your ecom platforms. Manage ecom stores, shipping, currencies etc on each market.</p>',
          columns: [true, false]
        },
      ]
    },
  ]
};



// WEBPACK FOOTER //
// ./pages/content/portalOverview_EN.js